import { render, staticRenderFns } from "./PirProgressionChart.vue?vue&type=template&id=67fadb81&scoped=true&"
import script from "./PirProgressionChart.vue?vue&type=script&lang=js&"
export * from "./PirProgressionChart.vue?vue&type=script&lang=js&"
import style0 from "./PirProgressionChart.vue?vue&type=style&index=0&id=67fadb81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fadb81",
  null
  
)

export default component.exports